'use client';

import { createContext } from 'react';

import type { CartContextProps } from '../types';

export const CartContext = createContext<CartContextProps | undefined>(undefined);
